import { Component, Input, OnInit } from "@angular/core";
import { IConfigData } from "../../interfaces/configData.interface";
import { IImmoconnData } from "../../interfaces/immoconnData.interface";
import { UiHelperService } from "../../services/ui-helper.service";

@Component({
  selector: "app-data-result",
  templateUrl: "./data-result.component.html",
  styleUrls: ["./data-result.component.scss"],
})
export class DataResultComponent implements OnInit {
  @Input()
  public immoconnData?: IImmoconnData;

  @Input()
  public configData: IConfigData = {};

  constructor(public uiHelperService: UiHelperService) {}

  ngOnInit(): void {}
}
